import { Col, Popover, Row } from "antd";
import React, { Component } from "react";
import Images from "../../Images";
import { connect } from "react-redux";

export class HomeSlots extends Component {
  render() {
    const { landingSlotsGame, signedIn, history , navUrl } = this.props;
    return (
      <div className="home-slots">
        <div className="home-slots-headline">
          <h2 onClick={()=>history.push(navUrl)}>Slots</h2>
          {/* <span>See All</span> */}
        </div>
        <div className="slots-game-container">
        {landingSlotsGame.map((slot) => {
                return (
                  <div key={slot.gameId} className="img-container" style={slot.slotsPath ? (slot.slotsPath.includes('_s.')? {'--mobile-slots-width':"45%"} : {'--mobile-slots-width':"100%"}): {}}> 
                  {!signedIn ? (
                      <Popover
                        overlayClassName="popup-slots"
                        placement="bottom"
                        arrowPointAtCenter
                        content={<p> Please Sign in or Register </p>}
                        trigger="click"
                      >
                          <img
                            src={`${slot.slotsPath}?id=${slot.imageVersion}`}
                            alt="slot-game-image"
                            title={`${slot.gameName}`}
                          />{" "}
                      </Popover>
                    ) : (
                      <img
                        src={`${slot.slotsPath}?id=${slot.imageVersion}`}
                        alt="slot-game-image"
                        title={`${slot.gameName}`}
                        onClick={() =>
                          history.push(`/slots/game/${slot.gameId}`)
                        }
                      />
                    )}
                  </div>
                );
              })}
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    signedIn: state.auth.signedIn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeSlots);
